import { api } from "@/lib/api";

import type {
  CreateOpeningStockReq,
  ListOpeningStocksParams,
  OpeningStock,
  OpeningStockListResponse,
  UpdateOpeningStockReq,
} from "@artisancode/api-types";

export const openingStockService = {
  list: (params?: ListOpeningStocksParams) => {
    const query: Record<string, string | number | undefined> = {};
    const perPage = params?.perPage ?? params?.per_page;
    if (params?.page) query.page = params.page;
    if (perPage) query.per_page = perPage;
    if (params?.search) query.search = params.search;
    if (params?.status) query.status = params.status;
    if (params?.startDate) query.start_date = params.startDate;
    if (params?.endDate) query.end_date = params.endDate;

    return api.get<OpeningStockListResponse>("/opening-stocks", query);
  },

  detail: (id: string) => api.get<OpeningStock>(`/opening-stocks/${id}`),

  create: (body: CreateOpeningStockReq, idempotencyKey?: string) =>
    api.post<OpeningStock>(
      "/opening-stocks",
      body,
      idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    ),

  update: (id: string, body: UpdateOpeningStockReq) =>
    api.put<OpeningStock>(`/opening-stocks/${id}`, body),

  delete: (id: string) => api.del(`/opening-stocks/${id}`),

  complete: (id: string) =>
    api.post<OpeningStock>(`/opening-stocks/${id}/complete`, {}),
};
